var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkGreenShrub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.373,
    height: 148.57,
    viewBox: "0 0 145.373 148.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.899, -0.438, 0.438, -0.899, 101.372, 148.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.666,40.886c3.212-11.009,7.184-19.6,9.422-30.46C52.381,7.432,45.987,3.044,41.174,0A266.394,266.394,0,0,0,5.357,63.214C1.807,72.24-1.217,81.738.49,91.12c.648,3.567,3.4,8.822,8.585,9.231C14.609,100.8,22.2,94.539,25.2,90.7c9.836-12.552,15.279-25.2,22.466-49.812",
    transform: "translate(0 0)",
    fill: "#637a30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.489,97.235C42.858,68.17,35.6,39.423,27.268,11.052Q18.777,5.606,9.97,0A282.485,282.485,0,0,0,.78,55.3C-.453,73.943-1.913,89.391,10.9,107.779c3.363,4.824,10.389,10.215,17.092,9.259,9.9-1.418,13.106-11.612,13.495-19.8",
    transform: "translate(42.182 7.26)",
    fill: "#637a30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.457,61.466C56.709,56.042,53.906,50.593,51,45.611,46.477,37.872,32.369,17.436,26.437,10.18,15.476,3.028,12.132,7.758,0,0,8.112,21.643,18.608,44.552,35.64,61.644c3.85,3.861,9.986,7.938,15.349,5.567a8.09,8.09,0,0,0,4.469-5.745",
    transform: "translate(64.367 15.056)",
    fill: "#637a30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreenShrub);
export default __webpack_public_path__ + "static/media/dark-green-shrub.569eea447273deb99fec2be8a5d44a73.svg";
export { ForwardRef as ReactComponent };